import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {QuestionCircleOutlined} from '@ant-design/icons'
import {Button, DatePicker, message, Modal, Select} from "antd"
import {ListSource} from "../../../shared/Contants"
import {addCustomers, updateCustomers} from "../../../../services/api/apiCustomers"
import CustomerContext from "../../context/CustomerContext"
import moment from "moment"
import parseToken from "../../../../helpers/parseToken"

CustomerForm.propTypes = {
    item: PropTypes.object,
    type: PropTypes.string,
    label: PropTypes.string,
    createBy: PropTypes.string,
    text: PropTypes.string,
}

function CustomerForm(props) {
    const decodeToken = parseToken()
    const {item, label, type, text = '', createBy, fetchLeadDetail, setNameCus, conversation = {}} = props
    console.log(conversation)
    const {getCustomers} = useContext(CustomerContext)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [loading, setLoading] = useState(false)

    const [name, setName] = useState('')
    const [identityNumber, setIdentityNumber] = useState('')
    const [gender, setGender] = useState('Unknown')
    const [identityIssuingDate, setIdentityIssuingDate] = useState()
    const [phone, setPhone] = useState([])
    const [identityIssuingDepartment, setIdentityIssuingDepartment] = useState('')
    const [email, setEmail] = useState('')
    const [dateOfBirth, setDateOfBirth] = useState()
    const [customerType, setCustomerType] = useState(1)
    const [job, setJob] = useState('')
    const [zaloName, setZalo] = useState(conversation.userDisplayName || '')
    const [zaloUID, setZaloUID] = useState(conversation.userId || '')
    const [fbName, setFacebook] = useState('')
    const [fbUID, setFacebookID] = useState('')
    const [source, setSource] = useState(100)
    const [address, setAddress] = useState('')
    const [maritalStatus, setMaritalStatus] = useState('Single')
    const [updatedAt, setUpdatedAt] = useState('')
    const [createdAt, setCreatedAt] = useState('')
    const [description, setDescription] = useState('')

    const [validate, setValidate] = useState({})
    const [phoneInput, setPhoneInput] = useState('')
    const [emailInput, setEmailInput] = useState('')

    const arrayUnique = (array) => {
        const a = array.concat()

        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j])
                    a.splice(j--, 1)
            }
        }

        return a
    }

    const _convertString = (string, position) => {
        const regex = /,\s|,|\n|\s/
        const parsed = string.split(regex)
        let check = !!parsed && parsed.length > 0 && parsed.filter(item => item !== "")
        let combinedArray = [].concat(position === 'first' ? phone : phone)

        if (combinedArray.length === 0) {
            return check
        } else {
            return check.filter(x => !combinedArray.includes(x))
        }
    }

    const _checkString = (string, e) => {
        const regex = /,\s|,|\n|\s/gi

        return regex.test(string)
    }

    const _handleChangeName = (e) => {
        const {value} = e.target
        setName(value)
    }

    const _handleChangeIdentityNumber = (e) => {
        const {value} = e.target
        setIdentityNumber(value)
    }

    const _handleChangeIdentityIssuingDate = (date, dateString) => {
        setIdentityIssuingDate(dateString)
    }

    const _handleChangeIdentityIssuingDepartment = (e) => {
        const {value} = e.target
        setIdentityIssuingDepartment(value)
    }

    const _handleChangeDateOfBirth = (date, dateString) => {
        setDateOfBirth(dateString)
    }

    const _handleChangeJob = (e) => {
        const {value} = e.target
        setJob(value)
    }

    const _handleChangeZalo = (e) => {
        const {value} = e.target
        setZalo(value)
    }

    const _handleChangeZaloUID = (e) => {
        const {value} = e.target
        setZaloUID(value)
    }

    const _handleChangeFacebook = (e) => {
        const {value} = e.target
        setFacebook(value)
    }

    const _handleChangeFacebookID = (e) => {
        const {value} = e.target
        setFacebookID(value)
    }

    const _handleChangeAddress = (e) => {
        const {value} = e.target
        setAddress(value)
    }

    const _handleChangeDescription = (e) => {
        const {value} = e.target;

        setDescription(value);
    }

    const _handleChangeSources = (value) => {
        setSource(value)
    }

    const _validateData = () => {
        let validateForm = {}

        if (name.trim() === '') {
            Object.assign(validateForm, {name: 'Tên khách hàng là bắt buộc.'})
        }

        if (identityNumber.length > 40) {
            Object.assign(validateForm, {identityNumber: 'Số CMTND/CCCD ít hơn 40 ký tự.'})
        }

        const regex = /\S+@\S+\.\S+/

        if (email.length > 0 && !regex.test(email)) {
            Object.assign(validateForm, {email: 'Email không đúng định dạng.'})
        }

        const regexPhone = /^[0-9]\d*$/
        if (phone.length > 0) {
            for (let i = 0; i < phone.length; i++) {
                if (!regexPhone.test(phone[i]) || (phone[i].indexOf('0') === 0 && phone[i].length !== 10) || (phone[i].indexOf('0') !== 0 && phone[i].length !== 9)) {
                    Object.assign(validateForm, {phone: 'Số điện thoại không đúng định dạng.'})
                }
            }
        }

        setValidate(validateForm)

        return validateForm
    }

    const showModal = () => {
        setIsModalVisible(true)
    }

    const handleCancel = () => {
        setIsModalVisible(false)
        _resetCustomerInfo()

        if (type === 'edit') {
            setName(item.name || '')
            setPhone((!!item && !!item.phone && item.phone.split(',')) || [])
            setEmail((!!item && !!item.email && item.email.split(',')) || [])
            setSource(item.customerSourceId || 100)
            setCustomerType(item.customerTypeId || 1)
            setIdentityNumber(item.identityNumber || '')
            setIdentityIssuingDepartment(item.identity_issuing_department || '')
            setIdentityIssuingDate(item.identityIssuingDate || '')
            setDateOfBirth(item.dateOfBirth || '')
            setJob(item.job || '')
            setZalo(item.zaloName || '')
            setZaloUID(item.zaloUID || '')
            setFacebook(item.fbName || '')
            setFacebookID(item.fbUID || '')
            setAddress(item.address || '')
            setMaritalStatus(item.maritalStatus || 'Single')
            setGender(item.gender || 'Unknown')
            setCreatedAt(moment(item.createdAt).format('YYYY-MM-DD') || '')
            setUpdatedAt(moment(item.updatedAt).format('YYYY-MM-DD') || '')
            setDescription(item.description)
        }
    }

    const _onUpdateCustomer = async () => {
        setLoading(true)

        try {
            const validateCheck = _validateData()

            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)

                return false
            }

            const payload = {
                id: item.customerId,
                name,
                phone: phone.length > 0 ? phone.join(',') : '',
                email: email.length > 0 ? email.join(',') : '',
                customerType,
                source,
                gender,
                identityIssuingDepartment,
                identityIssuingDate,
                identityNumber,
                dateOfBirth,
                job,
                zaloName,
                zaloUID,
                fbName,
                fbUID,
                address,
                maritalStatus,
                createBy,
                createdAt,
                updatedAt: moment().format('YYYY-MM-DD'),
                description
            }
            const response = await updateCustomers(payload, decodeToken.sub)

            const {success} = response

            if (success !== '1') {
                setLoading(false)

                return message.error("Cập nhật không thành công.")
            }

            setLoading(false)
            message.success("Cập nhật thành công.")
            handleCancel()
            if (typeof getCustomers === 'function') {
                getCustomers()
            }
            if (typeof fetchLeadDetail === 'function') {
                fetchLeadDetail()
            }
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _onAddCustomer = async () => {
        setLoading(true)

        try {
            const validateCheck = _validateData()

            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)

                return false
            }

            const payload = {
                createBy: createBy || 'dongshyshiny',
                name,
                phone: phone.length > 0 ? phone.join(',') : '',
                email: email.length > 0 ? email.join(',') : '',
                source,
                identityIssuingDepartment,
                identityIssuingDate,
                identityNumber,
                dateOfBirth,
                job,
                zaloName,
                zaloUID,
                fbName,
                fbUID,
                address,
                description
            }
            const response = await addCustomers(payload)

            const {data, success, error_message} = response

            if (success !== '1') {
                setLoading(false)

                return message.error(error_message)
            }

            setLoading(false)
            if (typeof setNameCus === 'function') {
                let itemCus = data.length > 0 ? {customerId: data[0].id, name: data[0].name} : {}
                setNameCus(itemCus)
            }
            message.success("Thêm mới khách hàng thành công.")
            if (typeof getCustomers === 'function') {
                getCustomers()
            }
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const handleOk = async () => {
        Modal.confirm({
            title: 'Confirm',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn lưu khách hàng này?',
            okText: 'Save',
            cancelText: 'Cancel',
            onOk: onSave
        })
    }

    const confirmCancel = () => {
        Modal.confirm({
            title: 'Confirm',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn thoát?',
            okText: 'Yes',
            cancelText: 'Cancel',
            onOk: handleCancel
        })
    }

    const onSave = async () => {
        if (type === 'edit') {
            await _onUpdateCustomer()
        } else {
            const response = await _onAddCustomer()

            if (response !== false) {
                handleCancel()
            }
        }
    }

    const onSaveAndNew = async () => {
        const response = await _onAddCustomer()

        if (response !== false) {
            await _resetCustomerInfo()
        }
    }

    const handleOkAndNew = async () => {
        Modal.confirm({
            title: 'Confirm',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn lưu và tạo mới khách hàng?',
            okText: 'Save',
            cancelText: 'Cancel',
            onOk: onSaveAndNew
        })
    }

    const _onRemoveValuePhone = (value) => {
        const newArray = phone.filter(item => item !== value)

        setPhone(newArray)
    }

    const _onRemoveValueEmail = (value) => {
        const newArray = email.filter(item => item !== value)

        setEmail(newArray)
    }

    const _onPasteInputPhone = (e) => {
        const value = e.clipboardData.getData('Text')
        const input = _convertString(value, 'first')
        const newValue = arrayUnique(phone.concat(input))

        setPhone(newValue)
    }

    const _handleChangeInputPhone = (e) => {
        const {value} = e.target
        setPhoneInput(value)
        const input = _convertString(value, 'first')
        const check = _checkString(value)
        console.log(value, check)
        if ((!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const newValue = arrayUnique(phone.concat(input))

            setPhone(newValue)
            setPhoneInput('')
        }
    }

    const _onPasteInputEmail = (e) => {
        const value = e.clipboardData.getData('Text')
        const input = _convertString(value, 'first')
        const newValue = arrayUnique(email.concat(input))

        setEmail(newValue)
    }

    const _handleChangeInputEmail = (e) => {
        const {value} = e.target
        setEmailInput(value)
        const input = _convertString(value, 'first')
        const check = _checkString(value)

        if ((!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const newValue = arrayUnique(email.concat(input))

            setEmail(newValue)
            setEmailInput('')
        }
    }

    const _resetCustomerInfo = () => {
        setName('')
        setIdentityNumber('')
        setGender('Unknown')
        setIdentityIssuingDate('')
        setPhone('')
        setIdentityIssuingDepartment('')
        setEmail('')
        setDateOfBirth('')
        setCustomerType(1)
        setJob('')
        setZalo('')
        setZaloUID('')
        setFacebook('')
        setFacebookID('')
        setSource(100)
        setAddress('')
        setMaritalStatus('Single')
        setDescription('')
    }

    useEffect(() => {
        if (type !== 'add') {
            setName(item.name || '')
            setPhone((!!item && !!item.phone && item.phone.split(',')) || [])
            setEmail((!!item && !!item.email && item.email.split(',')) || [])
            setSource(item.customerSourceId || 100)
            setCustomerType(item.customerTypeId || 1)
            setIdentityNumber(item.identityNumber || '')
            setIdentityIssuingDepartment(item.identity_issuing_department || '')
            setIdentityIssuingDate(item.identityIssuingDate || '')
            setDateOfBirth(item.dateOfBirth || '')
            setJob(item.job || '')
            setZalo(item.zaloName || '')
            setZaloUID(item.zaloUID || '')
            setFacebook(item.fbName || '')
            setFacebookID(item.fbUID || '')
            setAddress(item.address || '')
            setMaritalStatus(item.maritalStatus || 'Single')
            setGender(item.gender || 'Unknown')
            setCreatedAt(moment(item.createdAt).format('YYYY-MM-DD') || '')
            setUpdatedAt(moment(item.updatedAt).format('YYYY-MM-DD') || '')
            setDescription(item.description)
        }
        // eslint-disable-next-line
    }, [item])

    return (
        <div className="CustomerForm">
            {
                type === 'edit' ?
                    text === 'name' ?
                        <span className="Content Link" onClick={showModal}>{name}</span>
                        :
                        <span className="material-icons" onClick={showModal}>border_color</span>
                    :
                    <button className="ButtonCustom" onClick={showModal}>
                        <span className="material-icons">add</span>
                        <span>Add new</span>
                    </button>
            }

            <Modal
                title={label}
                className="ModalCustom"
                centered
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={confirmCancel}
                footer={[
                    <Button key="back" onClick={confirmCancel}>
                        Cancel
                    </Button>,
                    <Button className={`${type}`} key="submit2" type="primary" loading={loading}
                            onClick={handleOkAndNew}>
                        Save & New
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                        Save
                    </Button>
                ]}
            >
                <div className="FormEdit">
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Tên khách hàng
                                <span className="Required">*</span>
                            </label>

                            <input
                                className={`${validate.name ? 'Error' : ''}`}
                                id="name"
                                type="text"
                                name="name"
                                placeholder="Tên khách hàng..."
                                value={name}
                                onChange={_handleChangeName}
                            />

                            {
                                validate.name && <span className="Error">{validate.name}</span>
                            }
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="source">Nguồn khách hàng</label>
                            <Select id="source" value={source} onChange={_handleChangeSources}>
                                {
                                    !!ListSource && ListSource.length > 0 && ListSource.map((item) => (
                                        <Select.Option key={`source_${item.value}`}
                                                       value={item.value}>{item.name}</Select.Option>
                                    ))
                                }
                            </Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="phone">
                                Số điện thoại(dùng cách hoặc , để kết thúc)
                            </label>

                            <div className="CustomSelect ant-input">
                                <div className="Selected">
                                    {
                                        !!phone && phone.length > 0 && phone.map((item, index) => (
                                            <span key={`allow-${index}`} className="Results">
                                                <span>{item}</span>
                                                <i
                                                    className='material-icons ml-1'
                                                    onClick={() => _onRemoveValuePhone(item)}
                                                >close</i>
                                            </span>
                                        ))
                                    }

                                    <div className="Input">
                                        <input
                                            type="text"
                                            value={phoneInput}
                                            name='allow'
                                            onPaste={_onPasteInputPhone}
                                            onChange={_handleChangeInputPhone}
                                            placeholder="Dùng space hoặc ,"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="email">Email</label>
                            <div className="CustomSelect ant-input">
                                <div className="Selected">
                                    {
                                        !!email && email.length > 0 && email.map((item, index) => (
                                            <span key={`allow-${index}`} className="Results">
                                                <span>{item}</span>
                                                <i
                                                    className='material-icons ml-1'
                                                    onClick={() => _onRemoveValueEmail(item)}
                                                >close</i>
                                            </span>
                                        ))
                                    }

                                    <div className="Input">
                                        <input
                                            type="text"
                                            value={emailInput}
                                            name='allow'
                                            onPaste={_onPasteInputEmail}
                                            onChange={_handleChangeInputEmail}
                                        />
                                    </div>
                                </div>
                            </div>
                            {
                                validate.email && <span className="Error">{validate.email}</span>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="zaloName">
                                Tên Zalo
                            </label>
                            <input
                                id="zaloName"
                                type="text"
                                name="zaloName"
                                placeholder="Tên Zalo"
                                value={zaloName}
                                onChange={_handleChangeZalo}
                            />
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="zaloUID">
                                Zalo UID
                            </label>
                            <input
                                id="zaloUID"
                                type="text"
                                name="zaloUID"
                                placeholder="Zalo UID"
                                value={zaloUID}
                                onChange={_handleChangeZaloUID}
                            />
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="fbName">
                                Tên Facebook
                            </label>
                            <input
                                id="fbName"
                                type="text"
                                name="fbName"
                                placeholder="Tên Facebook"
                                value={fbName}
                                onChange={_handleChangeFacebook}
                            />
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="fbUID">
                                Facebook ID
                            </label>
                            <input
                                id="fbUID"
                                type="text"
                                name="fbUID"
                                placeholder="Facebook ID"
                                value={fbUID}
                                onChange={_handleChangeFacebookID}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="job">
                                Nghề nghiệp
                            </label>
                            <input
                                className={`${validate.job ? 'Error' : ''}`}
                                id="job"
                                type="text"
                                name="job"
                                placeholder="Nghề nghiệp..."
                                value={job}
                                onChange={_handleChangeJob}
                            />
                            {
                                validate.job && <span className="Error">{validate.job}</span>
                            }
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="address">
                                Địa chỉ
                            </label>
                            <input
                                className={`${validate.address ? 'Error' : ''}`}
                                id="address"
                                type="text"
                                name="address"
                                placeholder="Địa chỉ..."
                                value={address}
                                onChange={_handleChangeAddress}
                            />
                            {
                                validate.address && <span className="Error">{validate.address}</span>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="identityNumber">
                                Số CMND/CCCD
                            </label>

                            <input
                                id="identityNumber"
                                className={`${validate.identityNumber ? 'Error' : ''}`}
                                type="text"
                                name="identityNumber"
                                placeholder="Số CMTND/CCCD..."
                                value={identityNumber}
                                onChange={_handleChangeIdentityNumber}
                            />

                            {
                                validate.identityNumber && <span className="Error">{validate.identityNumber}</span>
                            }
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="phone">
                                Ngày cấp(YYYY-MM-DD)
                            </label>
                            <DatePicker
                                defaultValue={!!identityIssuingDate ? moment(identityIssuingDate, 'YYYY-MM-DD') : null}
                                format={'YYYY-MM-DD'}
                                onChange={_handleChangeIdentityIssuingDate}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="identityIssuingDepartment">
                                Nơi cấp
                            </label>
                            <input
                                className={`${validate.identityIssuingDepartment ? 'Error' : ''}`}
                                id="identityIssuingDepartment"
                                type="text"
                                name="identityIssuingDepartment"
                                placeholder="Nơi cấp..."
                                value={identityIssuingDepartment}
                                onChange={_handleChangeIdentityIssuingDepartment}
                            />
                            {
                                validate.identityIssuingDepartment &&
                                <span className="Error">{validate.identityIssuingDepartment}</span>
                            }
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="dateOfBirth">
                                Ngày sinh(YYYY-MM-DD)
                            </label>
                            <DatePicker
                                defaultValue={!!dateOfBirth ? moment(dateOfBirth, 'YYYY-MM-DD') : null}
                                format={'YYYY-MM-DD'}
                                onChange={_handleChangeDateOfBirth}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="FormField col-md-12">
                            <label className="Label" htmlFor="description">
                                Mô tả
                            </label>
                            <textarea
                                name="description"
                                id="description"
                                cols="30"
                                rows="3"
                                placeholder="Nhập vào mô tả khách hàng"
                                value={description}
                                onChange={_handleChangeDescription}
                            />
                        </div>
                    </div>

                    {
                        type === 'edit' && <div className="row">
                            <div className="FormField col-md-6">
                                <label className="Label" htmlFor="createAt">
                                    Ngày tạo
                                </label>
                                <input
                                    id="createAt"
                                    type="text"
                                    name="createAt"
                                    value={createdAt}
                                    disabled
                                />
                            </div>
                            <div className="FormField col-md-6">
                                <label className="Label" htmlFor="updateAt">
                                    Ngày cập nhật
                                </label>
                                <input
                                    id="updateAt"
                                    type="text"
                                    name="updateAt"
                                    value={updatedAt}
                                    disabled
                                />
                            </div>
                        </div>
                    }
                </div>
            </Modal>
        </div>
    )
}

export default CustomerForm
